import { cssColorValue, cssSpacing } from '@spotify-internal/encore-web';
import styled from 'styled-components';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${cssSpacing('looser')};

  background-color: ${cssColorValue('backgroundBase')};
  color: ${cssColorValue('textBase')};
  width: 100%;
`;
